<template>
  <va-card :title="$t('tables.contracts')">
    <template slot="actions">
      <va-button icon="fa fa-refresh" color="info" @click="refresh()" :disabled="loading == true"/>
      <va-button icon="fa fa-gear" color="info" :disabled="loading == true" />
      <va-button icon="fa fa-plus" color="info" :disabled="loading == true" @click="add()"/>
    </template>
    <div class="row align--center mb-1">
      <div class="flex xs12 sm6">
        <va-input
          class="ma-0"
          :value="term"
          :placeholder="$t('search.searchByEmployee')"
          @input="search"
        >
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
      <div class="flex xs12 sm6">
        <va-checkbox v-model="includeFinished" label="Show finished contracts" :disabled="loading == true"></va-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="flex xs12">
        <div class="row">
          <div class="flex xs12">
            <va-data-table
              :fields="fields"
              :data="filteredData"
              :per-page="15"
              clickable
              :loading="loading"
              hoverable
            >
              <template slot="icon">
                <va-icon name="fa fa-handshake-o" color="secondary" />
              </template>
              <template slot="status" slot-scope="props">
                <va-badge
                  :color="getBadgeColor(props.rowData.finished)"
                >{{ getBadgeText(props.rowData.finished) }}</va-badge>
              </template>
              <template slot="actions" slot-scope="props">
                <va-button
                  flat
                  small
                  color="info"
                  icon="fa fa-pencil"
                  @click="editItem(props.rowData)"
                />
                <va-button
                  flat
                  small
                  color="danger"
                  icon="fa fa-trash"
                  @click="deleteItem(props.rowData)"
                />
              </template>
            </va-data-table>
          </div>
        </div>
      </div>
    </div>
    <div class="modals">
      <div class="flex xs12">
        <va-modal
          size="large"
          max-width="100%"
          v-model="editDialog"
          :title=" $t('modal.editTitle') "
          cancelClass="none"
          :okText=" $t('modal.confirm') "
          :message="message"
          noOutsideDismiss
          noEscDismiss
          @cancel="close"
          @ok="save"
        >
          <div class="form-elements">
            <form>
              <div class="row">
                <div class="flex xs12">
                  <va-select
                    placeholder="Select Employee"
                    label="Employee"
                    v-model="editedItem.employee"
                    :options="activeEmployees"
                    textBy="full_name"
                    clearable="false"
                    idBy="employee_id"
                  />
                </div>
              </div>
              <div class="row">
                <div class="flex xs12">
                  <va-select
                    placeholder="Select Manager"
                    label="Manager"
                    v-model="editedItem.manager"
                    :options="activeManagers"
                    clearable="false"
                    textBy="full_name"
                    idBy="manager_id"
                  />
                </div>
              </div>
              <div class="row">
                <div class="flex xs12">
                  <va-select
                    placeholder="Select State"
                    label="State"
                    v-model="editedItem.selectedState"
                    :options="states"
                    clearable="false"
                    textBy="name"
                    idBy="id"
                  />
                </div>
              </div>
              <div class="row">
                <div class="flex xs12">
                  <va-input
                    v-model="editedItem.description"
                    placeholder="Contract description"
                    type="textarea"
                    :minRows="3"
                    :maxRows="8"
                  />
                </div>
              </div>
              <div class="row">
                <div class="flex xs12">
                  <va-date-picker
                    :label="$t('tables.contractHeadings.startDate')"
                    v-model="editedItem.start_date"
                    :config="{dateFormat: 'd/m/Y'}"
                    weekDays
                  />
                </div>
              </div>
              <div class="row">
                <div class="flex xs12">
                  <va-date-picker
                    :label="$t('tables.contractHeadings.endDate')"
                    v-model="editedItem.finish_date"
                    :config="{dateFormat: 'd/m/Y'}"
                    weekDays
                  />
                </div>
              </div>
              <div class="row">
                <div class="flex xs12">
                  <va-checkbox v-model="editedItem.finished" label="Finished"></va-checkbox>
                </div>
              </div>
            </form>
          </div>
        </va-modal>
      </div>
    </div>
  </va-card>
</template>

<script>
import contractService from '../../../api/contractService'
import dataFactory from '../../../api/dataFactoryService'
import { debounce } from 'lodash'

export default {
  data () {
    return {
      loading: false,
      editDialog: false,
      deleteDialog: false,
      includeFinished: false,
      states: [
        {
          id: 'nsw',
          name: 'NSW',
        },
        {
          id: 'qld',
          name: 'QLD',
        },
        {
          id: 'sa',
          name: 'SA',
        },
        {
          id: 'tas',
          name: 'Tas',
        },
        {
          id: 'vic',
          name: 'VIC',
        },
        {
          id: 'wa',
          name: 'WA',
        },
        {
          id: 'act',
          name: 'ACT',
        },
      ],
      term: null,
      message: '',
      contracts: [],
      activeEmployees: [],
      activeManagers: [],
      managers: [],
      employees: [],
      editedIndex: -1,
      editedItem: {
        id: '',
        employee_id: '',
        state: '',
        manager_id: '',
        selectedState: {
          id: '',
          name: '',
        },
        description: '',
        finished: false,
        start_date: '',
        finish_date: '',
        employee_name: '',
        manager_name: '',
        employee: {
          employee_id: '',
          full_name: '',
        },
        manager: {
          manager_id: '',
          full_name: '',
        },
        last_date: '',
      },
      defaultItem: {
        id: '',
        employee_id: '',
        state: '',
        manager_id: '',
        description: '',
        selectedState: {
          id: '',
          name: '',
        },
        finished: false,
        start_date: '',
        finish_date: '',
        employee_name: '',
        manager_name: '',
        employee: {
          employee_id: '',
          full_name: '',
        },
        manager: {
          manager_id: '',
          full_name: '',
        },
        last_date: '',
      },
    }
  },
  computed: {
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.contracts
      }
      return this.contracts.filter(item => {
        return item.employee.full_name
          .toLowerCase()
          .includes(this.term.toLowerCase())
      })
    },
    fields () {
      return [
        {
          name: '__slot:icon',
          width: '25px',
          dataClass: 'text-center',
        },
        {
          name: 'employee.full_name',
          title: this.$t('tables.contractHeadings.employee'),
          sortField: 'employee_name',
          width: '20%',
        },
        {
          name: 'manager.full_name',
          title: this.$t('tables.contractHeadings.manager'),
          sortField: 'manager_name',
          width: '20%',
        },
        {
          name: 'selectedState.name',
          title: this.$t('tables.contractHeadings.state'),
          sortField: 'state',
          width: '7%',
        },
        {
          name: '__slot:status',
          title: this.$t('tables.contractHeadings.status'),
          width: '10%',
        },
        {
          name: 'start_date',
          title: this.$t('tables.contractHeadings.startDate'),
          sortField: 'start_date',
          width: '12%',
        },
        {
          name: 'finish_date',
          title: this.$t('tables.contractHeadings.endDate'),
          sortField: 'finish_date',
          width: '12%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        },
      ]
    },
  },

  watch: {
    editDialog (val) {
      // val || this.close()
      if (val) {
        console.log('close called')
      }
    },
    async includeFinished (val) {
      if (val) {
        await this.initialize()
      } else {
        await this.initialize()
      }
    },
  },

  async created () {
    await this.initialize()
  },

  methods: {
    async refresh () {
      await this.initialize()
      console.log('refresh')
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
    getBadgeColor (status) {
      if (status === true) {
        return 'success'
      } else {
        return 'info'
      }
    },
    getBadgeText (status) {
      if (status === true) {
        return 'finished'
      } else {
        return 'in progress'
      }
    },
    async initialize () {
      this.loading = true
      try {
        let contractResult = await contractService.getActive(this.includeFinished)
        this.employees = dataFactory.createEmployeeViewListModel(
          contractResult.payload.data.employees
        )
        this.activeEmployees = this.employees.filter(r => r.inactive === false)
        this.managers = dataFactory.createManagerViewListModel(
          contractResult.payload.data.managers
        )
        this.activeManagers = this.managers.filter(r => r.inactive === false)
        this.contracts = dataFactory.createContractListModel(
          contractResult.payload.data.contracts,
          this.managers,
          this.employees,
          this.states
        )
      } catch (error) {
        this.showToast(error, {
          icon: 'fa-exclamation',
          position: 'bottom-right',
          duration: 5000,
        })
      }
      this.loading = false
    },

    editItem (item) {
      this.editedIndex = this.contracts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editDialog = true
      this.message = 'Edit the selected contract. You can finalise the contract by checking the finish checkbox.'
    },

    async deleteItem (item) {
      const index = this.contracts.indexOf(item)
      if (confirm('Are you sure you want to delete this item?')) {
        try {
          await contractService.delete(item.id)
          this.contracts.splice(index, 1)
        } catch (error) {
          this.showToast(error, {
            icon: 'fa-exclamation',
            position: 'bottom-right',
            duration: 5000,
          })
        }
      }
    },

    close () {
      this.editDialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    },
    async save () {
      try {
        this.loading = true
        this.editedItem.manager_id = this.editedItem.manager.manager_id
        this.editedItem.employee_id = this.editedItem.employee.employee_id
        this.editedItem.manager_name = this.editedItem.manager.full_name
        this.editedItem.employee_name = this.editedItem.employee.full_name
        this.editedItem.state = this.editedItem.selectedState.id
        if (this.editedIndex > -1) {
          await contractService.update(this.editedItem.id, this.editedItem)
          Object.assign(this.contracts[this.editedIndex], this.editedItem)
        } else {
          var creationResult = await contractService.create(this.editedItem)
          this.editedItem.id = creationResult.payload.data
          this.contracts.push(this.editedItem)
        }
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
      } catch (error) {
        this.showToast(error, {
          icon: 'fa-exclamation',
          position: 'bottom-right',
          duration: 5000,
        })
      }
      this.editDialog = false
      this.loading = false
    },

    add () {
      this.editDialog = true
      this.message = 'Add a new contract. You can finalise the contract by checking the finish checkbox.'
    },
  },
}
</script>

<style lang="scss">
</style>
